import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("strong", { class: "openingTimes h4-responsive strong d-block mb-2 w-100" }, "Öffnungszeiten:", -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "10",
    cy: "20",
    r: "8"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "25",
    y: "15",
    rx: "5",
    ry: "5",
    width: "360",
    height: "10"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "10",
    cy: "50",
    r: "8"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "25",
    y: "45",
    rx: "5",
    ry: "5",
    width: "360",
    height: "10"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "10",
    cy: "80",
    r: "8"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "25",
    y: "75",
    rx: "5",
    ry: "5",
    width: "360",
    height: "10"
}, null, -1);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("circle", {
    cx: "10",
    cy: "110",
    r: "8"
}, null, -1);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("rect", {
    x: "25",
    y: "105",
    rx: "5",
    ry: "5",
    width: "360",
    height: "10"
}, null, -1);
const _hoisted_10 = {
    key: 1,
    class: "font7-responsive mb-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_content_loader = _resolveComponent("content-loader");
    const _component_opening_time_per_day = _resolveComponent("opening-time-per-day");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _hoisted_1,
        (null === _ctx.opening_times)
            ? (_openBlock(), _createBlock(_component_content_loader, {
                key: 0,
                viewBox: "0 0 400 150",
                speed: 2,
                primaryColor: "#ababab",
                secondaryColor: "#dedede"
            }, {
                default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3,
                    _hoisted_4,
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9
                ]),
                _: 1
            }))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Montag",
                    "opening-times": _ctx.openingTimes(1)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Dienstag",
                    "opening-times": _ctx.openingTimes(2)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Mittwoch",
                    "opening-times": _ctx.openingTimes(3)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Donnerstag",
                    "opening-times": _ctx.openingTimes(4)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Freitag",
                    "opening-times": _ctx.openingTimes(5)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Samstag",
                    "opening-times": _ctx.openingTimes(6)
                }, null, 8, ["opening-times"]),
                _createVNode(_component_opening_time_per_day, {
                    "day-name": "Sonntag",
                    "opening-times": _ctx.openingTimes(7)
                }, null, 8, ["opening-times"])
            ]))
    ], 64));
}
